import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { FormRule } from 'antd';

export function useEmailValidations(): FormRule[] {
    const { t } = useTranslation('auth');

    return useMemo<FormRule[]>(
        () => [
            {
                type: 'email',
                message: t('emailInputInvalidFormatError'),
            },
            {
                required: true,
                message: t('requiredControlError', {
                    controlName: t('emailInputLabel').toLowerCase(),
                    ns: 'translation',
                }),
            },
            {
                pattern: /^(\S{0,61})@/,
                message: t('emailInputMaxLocalPartLengthError'),
                validateTrigger: 'onSubmit',
            },
        ],
        [t],
    );
}
